import api from './api';

export const authFetch = async (body) => {
    const { data } = await api.post('/login', body);
    return data;
};

export const changeDataFetch = async (body) => {
    const data = await api.put('/v1/user', body);
    return data;
};

export const getUserFetch = async () => {
    const { data } = await api.get('/v1/user');
    return data;
};
